import React from 'react';
import { Box, Grid, Typography, FormHelperText } from '@mui/material';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import {
    Dropzone,
    FileMosaic,
    FullScreen,
    ImagePreview,
    VideoPreview,
} from '@dropzone-ui/react';
import Loading from '../../loadings/loading';
import { DropZoneFieldProps } from './props';
import { useDropZoneField } from './hook';

const DropZoneField = ({
    name,
    title = 'Arrastre y suelte algunos archivos aquí,',
    subtitle = 'o haga clic para seleccionar archivos',
    subtitle2 = 'Tipos de archivos aceptados:',
    accept = '.doc, .xls, .docx, .xlsx, .jpg, .pdf, .mp3, .mp4, .msg, .bmp, .png, .jpeg',
    maxFiles,
    maxFileSize,
    onChange,
    icon,
    currentFiles,
    loading,
    children,
    touched,
    errors,
}: DropZoneFieldProps) => {
    //onChange Formik
    //The variable dropzoneFieldFormik must be equal to the variable name of the formik
    //onChange={(value) => formik.setFieldValue('dropzoneFieldFormik', value)}

    const {
        files,
        imageSrc,
        videoSrc,
        updateFiles,
        removeFile,
        handleSee,
        handleWatch,
        setImageSrc,
        setVideoSrc,
    } = useDropZoneField({ accept, currentFiles, onChange, maxFileSize });

    return (
        <Grid position="relative">
            <Dropzone
                name={name}
                onChange={updateFiles}
                value={files}
                autoClean={true}
                maxFiles={maxFiles}
                localization="ES-es"
                footer={false}
                header={files.length > 0}
                maxFileSize={maxFileSize}
            >
                {files.length === 0 && (
                    <Box
                        mt={2}
                        component="span"
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ color: 'primary.main' }}
                    >
                        {children}
                        <Typography component="span">
                            <strong>{title}</strong>
                        </Typography>
                        {subtitle && (
                            <Typography component="span">
                                <strong>{subtitle}</strong>
                            </Typography>
                        )}
                        <Box mt={1}>
                            <Typography component="span">
                                <>
                                    {subtitle2 ? (
                                        <>
                                            {subtitle2}
                                            <br />
                                        </>
                                    ) : (
                                        ''
                                    )}
                                    {!accept ? (
                                        <strong>
                                            .png, .jpg, .jpeg, .txt, .csv, .doc,
                                            .docx, .xls, .xlsx, .pdf, <br />{' '}
                                            .video, .audio, .rar, .zip
                                        </strong>
                                    ) : (
                                        <strong>{accept}</strong>
                                    )}
                                </>
                            </Typography>
                        </Box>
                        {icon && (
                            <Box mt={1}>
                                <CloudUploadOutlinedIcon
                                    sx={{
                                        color: 'primary.main',
                                        fontSize: '3.5rem',
                                    }}
                                />
                            </Box>
                        )}
                    </Box>
                )}
                {files.length > 0 &&
                    files.map((file: any) => (
                        <FileMosaic
                            {...file}
                            onDelete={removeFile}
                            key={file.id}
                            info
                            preview
                            resultOnTooltip
                            alwaysActive
                            onSee={handleSee}
                            onWatch={() => handleWatch(file.file)}
                        />
                    ))}
            </Dropzone>

            {touched && errors && (
                <FormHelperText error sx={{ mt: 1, ml: 2 }}>
                    {errors}
                </FormHelperText>
            )}

            {loading && (
                <Grid
                    position="absolute"
                    top={0}
                    left={0}
                    width="100%"
                    height="100%"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    bgcolor="#0000001A"
                >
                    <Loading />
                </Grid>
            )}
            <FullScreen
                open={imageSrc !== undefined}
                onClose={() => setImageSrc(undefined)}
            >
                <ImagePreview src={imageSrc} />
            </FullScreen>
            <FullScreen
                open={videoSrc !== undefined}
                onClose={() => setVideoSrc(undefined)}
            >
                <VideoPreview src={videoSrc} autoPlay controls />
            </FullScreen>
        </Grid>
    );
};

export default DropZoneField;
